import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface CloudflareVerificationState {
  // Track which sources are verified
  verifiedSources: Record<string, boolean>
  
  // Track which sources were blocked (detected Cloudflare)
  blockedSources: Record<string, boolean>
  
  // Mark a source as verified
  setVerified: (sourceId: string) => void
  
  // Mark a source as blocked
  setBlocked: (sourceId: string) => void
  
  // Check if a source is verified
  isVerified: (sourceId: string) => boolean
  
  // Check if a source was blocked
  wasBlocked: (sourceId: string) => boolean
  
  // Clear verification for a source
  clearVerification: (sourceId: string) => void
  
  // Clear all verifications
  clearAll: () => void
}

export const useCloudflareVerificationStore = create<CloudflareVerificationState>()(
  persist(
    (set, get) => ({
      verifiedSources: {},
      blockedSources: {},
      
      setVerified: (sourceId: string) => {
        set((state) => ({
          verifiedSources: {
            ...state.verifiedSources,
            [sourceId]: true,
          },
        }))
        console.log(`[CloudflareVerification] ${sourceId} marked as verified`)
      },
      
      setBlocked: (sourceId: string) => {
        set((state) => ({
          blockedSources: {
            ...state.blockedSources,
            [sourceId]: true,
          },
        }))
        console.log(`[CloudflareVerification] ${sourceId} marked as blocked`)
      },
      
      isVerified: (sourceId: string) => {
        return get().verifiedSources[sourceId] === true
      },
      
      wasBlocked: (sourceId: string) => {
        return get().blockedSources[sourceId] === true
      },
      
      clearVerification: (sourceId: string) => {
        set((state) => {
          const newVerified = { ...state.verifiedSources }
          const newBlocked = { ...state.blockedSources }
          delete newVerified[sourceId]
          delete newBlocked[sourceId]
          return {
            verifiedSources: newVerified,
            blockedSources: newBlocked,
          }
        })
        console.log(`[CloudflareVerification] ${sourceId} verification cleared`)
      },
      
      clearAll: () => {
        set({
          verifiedSources: {},
          blockedSources: {},
        })
        console.log('[CloudflareVerification] All verifications cleared')
      },
    }),
    {
      name: 'cloudflare-verification-storage',
    }
  )
)
